import Vue from "vue";
import Router from "vue-router";

import { RouterTabRoutes } from "vue-router-tab";
import { session } from "../utils/session";
import Layout from '@/layout'
//解决重复路由跳转报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
    //base:process.env.VUE_APP_COMMON_PATH,
    //mode:'history',
    // scrollBehavior: () => ({ y: 0 }),
    routes: [
    //     {
    //     path: "/homePage",
    //     name: "HomePage",
    //     component: (resolve) => require(['@/views/homePage/index.vue'], resolve),
    // },
    {
        path: "/Login",
        name: "Login",
        component: (resolve) => require(['@/views/Login.vue'], resolve),
    }, {
        path: "/WechatAuthCallback",
        name: "WechatAuthCallback",
        component: (resolve) => require(['@/views/WechatAuth/WechatAuthCallbackURI.vue'], resolve),
        meta: {
            needLogin: true,
        }
    }, {
        path: "/ModifyPwd",
        name: "ModifyPwd",
        component: (resolve) => require(['@/views/personalCenter/ModifyPwd.vue'], resolve),
    },{
        path: "/uploadPwd",
        name: "UploadPwd",
        component: (resolve) => require(['@/views/personalCenter/uploadPwd.vue'], resolve),
    },
    {
        path: "/Register",
        name: "Register",
        component: (resolve) => require(['@/views/Register.vue'], resolve),
    },
    {
        path: "/GrapeCity",
        name: "GrapeCity",
        component: (resolve) => require(['@/views/grapeCity/grapeCityViewer.vue'], resolve),
    },
    {
        path: "/RegisterProtocal",
        name: "RegisterProtocal",
        component: (resolve) => require(['@/views/RegisterProtocal.vue'], resolve),
    },
    {
        path: "/",
        name: "Index",
        component: Layout,
        redirect: "/Home",
        children: [
            ...RouterTabRoutes,
            {
                path: "/Home",
                name: "Home",
                component: (resolve) => require(['@/views/Home/Home.vue'], resolve),
                meta: {
                    title: "首页",
                    closable: true,
                    needLogin: true, // 判断是否需要登录
                }
            },
            {
                path: "/workOrder/orderList/:type",
                name: "orderList",
                component: (resolve) => require(['@/views/WorkOrder/pages/OrderList.vue'], resolve),
                meta: {
                    title: "线索列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/workOrder/orderListHistory/:type",
                name: "orderListHistory",
                component: (resolve) => require(['@/views/WorkOrder/pages/OrderList.vue'], resolve),
                meta: {
                    title: "历史线索",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/workOrder/OrderListSalesFollowUp/:type",
                name: "orderListSalesFollowUp",
                component: (resolve) => require(['@/views/WorkOrder/pages/OrderList.vue'], resolve),
                meta: {
                    title: "销售跟进",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/workOrder/newWorkOrder/:type",
                name: "newWorkOrder",
                component: (resolve) => require(['@/views/WorkOrder/pages/newWorkOrder.vue'], resolve),
                meta: {
                    title: "新建线索",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/workOrder/workOrderDetail",
                name: "workOrderDetail",
                component: (resolve) => require(['@/views/WorkOrder/pages/workOrderDetail.vue'], resolve),
                meta: {
                    title: "线索详情",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/workOrder/auditWorkOrderDetail",
                name: "auditWorkOrderDetail",
                component: (resolve) => require(['@/views/WorkOrder/pages/auditWorkOrderDetail.vue'], resolve),
                meta: {
                    title: "线索审核详情",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/workOrder/examineWorkOrderDetail/:type",
                name: "examineWsorkOrderDetail",
                component: (resolve) => require(['@/views/WorkOrder/pages/examineWorkOrderDetail.vue'], resolve),
                meta: {
                    title: "审核单详情",
                    closable: true,
                    needLogin: true,
                }
            },
            // {
            //     path: "/SequenceNumberSettings",
            //     name: "SequenceNumberSettings",
            //     component: (resolve) => require(['@/views/BaseSettings/SequenceNumberSettings.vue'], resolve),
            //     meta: {
            //         title: "单号规则设置",
            //         closable: true,
            //         needLogin: true,
            //     }
            // },
            {
                path: "/basics/basics/dictionarySettings",
                name: "DictionarySettings",
                component: (resolve) => require(['@/views/BaseSettings/DictionarySettings.vue'], resolve),
                meta: {
                    title: "数据字典",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/account/auditSettings",
                name: "AuditSettings",
                component: (resolve) => require(['@/views/BaseSettings/AuditSettings.vue'], resolve),
                meta: {
                    title: "设置审核",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/basics/orgStructureSettings",
                name: "OrgStructureSettings",
                component: (resolve) => require(['@/views/BaseSettings/OrgStructureSettings.vue'], resolve),
                meta: {
                    title: "组织架构",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/account/accuntSettings",
                name: "AccuntSettings",
                component: (resolve) => require(['@/views/BaseSettings/AccuntSettings.vue'], resolve),
                meta: {
                    title: "账号管理",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/account/roleSettings",
                name: "RoleSettings",
                component: (resolve) => require(['@/views/BaseSettings/RoleSettings.vue'], resolve),
                meta: {
                    title: "角色管理",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/account/RoleEdit",
                name: "RoleEdit",
                component: (resolve) => require(['@/views/BaseSettings/RoleEdit.vue'], resolve),
                meta: {
                    title: "角色编辑",
                    needLogin: true,
                }
            },
            {
                path: "/basics/product/productCode",
                name: "ProductCode",
                component: (resolve) => require(['@/views/BaseSettings/ProductCode.vue'], resolve),
                meta: {
                    title: "打印商品码",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/product/productList",
                name: "ProductList",
                component: (resolve) => require(['@/views/BaseSettings/ProductList.vue'], resolve),
                meta: {
                    title: "商品列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/product/productBrand",
                name: "ProductBrand",
                component: (resolve) => require(['@/views/BaseSettings/ProductBrand.vue'], resolve),
                meta: {
                    title: "商品品牌",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/product/productProperty",
                name: "ProductProperty",
                component: (resolve) => require(['@/views/BaseSettings/ProductProperty.vue'], resolve),
                meta: {
                    title: "商品属性",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/supplier/supplierList",
                name: "SupplierList",
                component: (resolve) => require(['@/views/BaseSettings/SupplierList.vue'], resolve),
                meta: {
                    title: "供应商列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/customer/customerList",
                name: "CustomerList",
                component: (resolve) => require(['@/views/BaseSettings/CustomerList.vue'], resolve),
                meta: {
                    title: "客户列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/platform/registerList",
                name: "RegisterList",
                component: (resolve) => require(['@/views/platform/RegisterList.vue'], resolve),
                meta: {
                    title: "注册审核",
                    closable: true,
                    needLogin: true,
                }
            },
            // {
            //     path: "/platform/applyTrial",
            //     name: "ApplyTrial",
            //     component: (resolve) => require(['@/views/platform/applyTrial.vue'], resolve),
            //     meta: {
            //         title: "申请试用",
            //         closable: true,
            //         needLogin: true,
            //     }
            // },
            {
                path: "/borrowList",
                name: "borrowList",
                component: (resolve) => require(['@/views/borrow/borrowList.vue'], resolve),
                meta: {
                    title: "租赁执行中",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/borrowWaitList",
                name: "borrowWaitList",
                component: (resolve) => require(['@/views/borrow/borrowWaitList.vue'], resolve),
                meta: {
                    title: "租赁待执行",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/financialManagement/financeManager",
                name: "FinanceManager",
                component: (resolve) => require(['@/views/finacial/FinanceManager.vue'], resolve),
                meta: {
                    title: "期初",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/basics/warehouse/storeStatic",
                name: "StoreStatic",
                component: (resolve) => require(['@/views/store/storeStatic.vue'], resolve),
                meta: {
                    title: "库存统计",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/meterReading/meterReading",
                name: "MeterRading",
                component: (resolve) => require(['@/views/borrow/MeterRading.vue'], resolve),
                meta: {
                    title: "租赁列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/NoMeterManage",
                name: "NoMeterManage",
                component: (resolve) => require(['@/views/borrow/NoMeterManage.vue'], resolve),
                meta: {
                    title: "结算管理",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/meterReadingList",
                name: "MeterReadingList",
                component: (resolve) => require(['@/views/borrow/meterReadingList.vue'], resolve),
                meta: {
                    title: "抄表列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/machineList",
                name: "machineList",
                component: (resolve) => require(['@/views/borrow/machineList.vue'], resolve),
                meta: {
                    title: "租赁机器",
                    closable: true,
                    needLogin: true,
                }
            }, {
                path: "/repair/repairManagement",
                name: "RepairManagement",
                component: (resolve) => require(['@/views/repair/repairManagement.vue'], resolve),
                meta: {
                    title: "维修管理",
                    closable: true,
                    needLogin: true,
                }
            }, {
                path: "/test",
                name: "test",
                component: (resolve) => require(['@/views/test/test.vue'], resolve),
                meta: {
                    title: "测试",
                    closable: true,
                    needLogin: true,
                }
            }, {
                path: "/userAgreement",
                name: "userAgreement",
                component: (resolve) => require(['@/views/app/userAgreement.vue'], resolve),
                meta: {
                    title: "测试",
                    closable: true,
                    needLogin: true,
                }
            },{
                path: "/privacyAgreement",
                name: "privacyAgreement",
                component: (resolve) => require(['@/views/app/privacyAgreement.vue'], resolve),
                meta: {
                    title: "测试",
                    closable: true,
                    needLogin: true,
                }
            },{
                path: "/platform/menuList",
                name: "MenuList",
                component: (resolve) => require(['@/views/platform/menuList.vue'], resolve),
                meta: {
                    title: "菜单维护",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/messageList",
                name: "MessageList",
                component: (resolve) => require(['@/views/messageList/messageList.vue'], resolve),
                meta: {
                    title: "消息列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/member/memberList",
                name: "memberList",
                component: (resolve) => require(['@/views/member/memberList.vue'], resolve),
                meta: {
                    title: "服务商列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/member/addMember/:type",
                name: "Member",
                component: (resolve) => require(['@/views/member/addMember.vue'], resolve),
                meta: {
                    title: "新增服务商",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/member/memberDetail/:type",
                name: "memberDetail",
                component: (resolve) => require(['@/views/member/memberDetail.vue'], resolve),
                meta: {
                    title: "服务商详情",
                    closable: true,
                    needLogin: true,
                }
            },
            {
              path: "/accountBalance/historical",
              name: "historicalList",
              component: (resolve) => require(['@/views/accountBalance/historical/index.vue'], resolve),
              meta: {
                  title: "账户历史",
                  closable: true,
                  needLogin: true,
              }
          },
            {
                path: "/auditManagement/managementList",
                name: "managementList",
                component: (resolve) => require(['@/views/auditManagement/managementList.vue'], resolve),
                meta: {
                    title: "审核列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/appealManagement/appealList",
                name: "appealList",
                component: (resolve) => require(['@/views/appealManagement/appealList.vue'], resolve),
                meta: {
                    title: "申诉列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/rateSetting/rateList",
                name: "rateList",
                component: (resolve) => require(['@/views/rateSetting/rateList.vue'], resolve),
                meta: {
                    title: "费率列表",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/versions/Android",
                name: "Android",
                component: (resolve) => require(['@/views/versionsManage'], resolve),
                meta: {
                    title: "Android",
                    closable: true,
                    needLogin: true,
                }
            },
            {
                path: "/versions/ios",
                name: "Ios",
                component: (resolve) => require(["@/views/versionsManage"], resolve),
                meta: {
                    title: "Ios",
                    closable: true,
                    needLogin: true,
                }
            },
        ]
    },
    {
        path: '/404',
        component: (resolve) => require(['@/views/error/404'], resolve),
        hidden: true,
        meta: {
            title: "404",
            closable: true,
            needLogin: true,
        },
    }
    ],

});

router.beforeEach((to, from, next) => {

    if (to.name == 'Member') {
        to.meta.title = to.params.type == 'perfec' ? '完善服务商' : '新增服务商'
    }
    if (to.name == 'memberDetail') {
        to.meta.title = to.params.type == 'auditDetails' ? '审核服务商详情' : '服务商详情'
    }
    if (to.name == 'newWorkOrder') {
        to.meta.title = to.params.type == 'add' ? '新建线索' : '线索审核'
    }
    if (to.matched.some(record => record.meta.needLogin)) { // 判断该路由是否需要登录权限
        //  console.log('需要登录 isLoginNow?? ',session.getUserId());
        if (session.getUserId()) { // 判断当前的token是否存在 ； 登录存入的token
            next();
        }
        else {
            next({
                path: '/Login',
                //query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        next();
    }
});
// const constantRoutes = router
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js